"use client";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Icon, { ICON_SIZES, ICON_TYPE } from "./Icon";

type GdprComplianceBadgeProps = {
  isMinimized?: boolean;
};

export default function GdprComplianceBadge({
  isMinimized = false,
}: Readonly<GdprComplianceBadgeProps>) {
  const { t } = useTranslation("common");

  if (process.env.NEXT_PUBLIC_REGION !== "europe") {
    return null;
  }

  const label = t("gdprCompliant");

  return (
    <div
      aria-label={label}
      className={clsx(
        "mb-3",
        "flex",
        "items-center",
        "justify-center",
        "rounded-lg",
        "border",
        "border-neutral",
        "bg-100",
        "text-600",
        "shadow-sm",
        "transition-all",
        {
          "mx-auto h-8 w-8": isMinimized,
          "mx-1 gap-2 px-3 py-2": !isMinimized,
        }
      )}
    >
      <span className="flex text-emerald-600 dark:text-emerald-400">
        <Icon icon="shield-check" size={ICON_SIZES.XS} type={ICON_TYPE.SOLID} />
      </span>
      <span
        className={clsx(
          "overflow-hidden",
          "whitespace-nowrap",
          "text-xs",
          "font-medium",
          "tracking-wide",
          "uppercase",
          "transition-all",
          {
            "w-0 opacity-0": isMinimized,
            "w-full opacity-100": !isMinimized,
          }
        )}
      >
        {label}
      </span>
    </div>
  );
}
